// extracted by mini-css-extract-plugin
module.exports = {"error-message":"ErrorMessage_error-message__1BLAt"};